import { createFileRoute } from "@tanstack/react-router";
import CanParentsHelpAdultChild from "@/pages/articles/CanParentsHelpAdultChild";
export const Route = createFileRoute(
  "/can-parents-help-adult-child-get-depression-treatment",
)({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Helping Adult Children With Depression | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "How parents can support an adult child with depression without overstepping. Practical guidance and treatment options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:title",
          content:
            "Helping Adult Children With Depression | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "How parents can support an adult child with depression without overstepping. Practical guidance and treatment options in Coral Springs, FL Free consultation.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/can-parents-help-adult-child-get-depression-treatment",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/can-parents-help-adult-child-get-depression-treatment",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <CanParentsHelpAdultChild />;
}
